<template>
  <div  :class="isInviteUrl? 'invite-iframe':'decline-iframe'" >
    <iframe
      :src="`https://${queryUrl}`"
      class="w-full h-full border-0"
    >
    </iframe>
  </div>
</template>

<script>
  export default {
    name: "Main",
    data() {
      return {
        queryUrl: ''
      };
    },
    created() {
      this.queryUrl = this.$route.query.url;
      // console.log('this.queryUrl',this.queryUrl);
      this.$store.commit("SET_PAGE_TYPE", "aboutUs");
      this.$store.commit("SET_PAGE_FOOTER_BACKGROUND_COLOR", "linear-gradient(104.96deg, #F29300 0.72%, #FFC000 94.5%)");
      // console.log("Background Color", this.$store.state.pageFooterBackgroundColor);
    },
    computed: {
      isInviteUrl() {
        const arr = this.queryUrl.split('/');
        if (arr[2] === 'decline') return false;
        return true;
      }
    },
  };
</script>
<style scoped>
  .invite-iframe {
    height: 1200px;
    margin-top: 6rem;
  }
  .decline-iframe {
    height: 500px;
    margin-top: 6rem;
  }
</style>
